<div class="my-overlay" *ngIf="showOverlay$ | async" data-cy="LoadingScreen">
  <section fxLayout="column" fxLayoutAlign="start center" fxLayoutGap="1rem">
    <mat-spinner></mat-spinner>
    <h2>{{ message$ | async }}</h2>
  </section>
</div>
